import { RestSlice } from '../../../../../redux/rest.slice';
import { IppDataSourceParameter } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippParameterSlice = new RestSlice<IppDataSourceParameter>(
	localizationService.getLocalizedString('ipp.industryAccount.dataProviders.translations.parameters.heading'),
	Resource.IppDataSourceParameters
);
export default ippParameterSlice.rests.reducer;
